import React from 'react';
import './Mascot.css';

const Mascot = () => {
  return (
    <div className="mascot-divider">
      <img 
        src="/images/Rugged Red Logo Small With Mr. Rugged Red - Right Side Logo Interlock Dynamic - faded.png" 
        alt="Rugged Red Mascot" 
        className="mascot-image" 
      />
    </div>
  );
};

export default Mascot; 